<template>
<div>

<div class="row">
  <div class="col">
    <search-box @update-search="updateSearch" :search_term="mySearchTerm"></search-box>
  </div>
</div>

<b-card no-body class="shadow">
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="People" title-link-class="darklink">
          <b-card-text><view-live-feed @update-search="updateSearch" :search_term="mySearchTerm" :isbot="0" :site_id="site.id"></view-live-feed></b-card-text>
        </b-tab>
        <b-tab title="Bots" title-link-class="darklink">
          <b-card-text><view-live-feed @update-search="updateSearch" :search_term="mySearchTerm" :isbot="1" :site_id="site.id"></view-live-feed></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

<span v-show="tabIndex === 0">
  <visitor-graph :site_id="site.id"></visitor-graph>
  <div class="row mt-4">
    <div class="col-12 col-md-6 mb-4">
      <top-sources :site_id="site.id"></top-sources>
      <top-countries :site_id="site.id"></top-countries>
    </div>
    <div class="col-12 col-md-6 mb-4">
      <top-pages :site_id="site.id"></top-pages>
      <top-browsers :site_id="site.id"></top-browsers>
    </div>
  </div>
</span>

</div>
</template> 

<script>
export default {
  props: ['site'],
  data() {
    return {
      tabIndex: 0,
      mySearchTerm: '',
    };
  },

  methods: {
    updateSearch(newSearchTerm) {
      this.mySearchTerm = newSearchTerm;
    }

  }
}
</script>